import NProgress from "nprogress";
import "nprogress/nprogress.css";

import router from "@/router/index";
import store from "@/store";


NProgress.configure({
    easing: "ease", // 动画方式
    speed: 200, // 递增进度条的速度
    showSpinner: false, // 是否显示加载ico
    trickleSpeed: 200, // 自动递增间隔
    minimum: 0.1, // 初始化时的最小百分比
});

router.beforeEach(async (to, from, next) => {
    NProgress.start();
    // 加载官网菜单
    if (!store.getters.website_nav.length) await store.dispatch("initAppMenus");
    // 用户刷新页面时，判断是否登录
    if(store.getters.user_id) await store.dispatch('refresh', {user_id: store.getters.user_id}).catch(() => {
        store.dispatch("logout").then(() => {
            next();
        });
    })
    next();
});

//当路由跳转结束后
router.afterEach((to) => {
    updateCurrentRoute(to)
    setAppTitle(to)
    // 关闭进度条
    NProgress.done();
});


/**
 * @description 设置页面标题
 * @param to
 */
function setAppTitle(to) {
    let func_title = to.meta && to.meta.title || null;
    if (to.query['_p_t_']) func_title = to.query['_p_t_'];
    document.title = func_title ? `${process.env.VUE_APP_TITLE} | ${func_title}` : process.env.VUE_APP_TITLE;
}

/**
 * @description 更新当前路由
 * @param to
 */
function updateCurrentRoute(to) {
    store.dispatch("updateCurrentRoute", to).then()
}